export default __webpack_public_path__ + "static/media/avatar1.ce022770.png";